import React, { memo } from "react";
import { LogOut } from "lucide-react";

const LogoutButton = ({ collapsed, onClick }) => (
  <button
    type="button"
    className="sb-sidebar__row sb-sidebar__row--leaf sb-sidebar__logout"
    onClick={onClick}
    aria-label="Log out"
  >
    <span className="sb-sidebar__row-icon">
      <LogOut size={18} aria-hidden />
    </span>
    {!collapsed && <span className="sb-sidebar__row-label">Logout</span>}
  </button>
);

export default memo(LogoutButton);
